export default __webpack_public_path__ + "static/media/ai_lidar.6511f618.svg";